/**
 * WP15 — magistrala salda zł (cross-cut).
 * Jedno źródło „aktualnego salda" dla HUD. Zapisują tu: RunClient (nagrody
 * z mini-gier) i ścieżki zakupów (OutfitStore). HUD subskrybuje i odświeża
 * licznik live. Czysty moduł (bez Phasera) — łatwy do testów jednostkowych.
 */
type Listener = (balance: number) => void;

let current: number | null = null;
const listeners = new Set<Listener>();

/** Normalizacja: całkowite, nieujemne. */
function normalize(balance: number): number | null {
  if (!Number.isFinite(balance)) return null;
  return Math.max(0, Math.floor(balance));
}

export const balanceBus = {
  /** Ostatnie znane saldo lub null (jeszcze nie znamy). */
  get(): number | null {
    return current;
  },

  /** Ustaw saldo autorytatywne (z serwera). Emituje tylko przy zmianie. */
  set(balance: number): void {
    const v = normalize(balance);
    if (v === null || v === current) return;
    current = v;
    for (const l of [...listeners]) l(v);
  },

  /**
   * Subskrypcja. Gdy saldo już znane — natychmiast wywołuje listener,
   * żeby HUD narysował aktualną wartość bez czekania na kolejny event.
   * Zwraca funkcję odsubskrybowania.
   */
  subscribe(l: Listener): () => void {
    listeners.add(l);
    if (current !== null) l(current);
    return () => {
      listeners.delete(l);
    };
  },

  /** Reset (testy / wylogowanie). */
  reset(): void {
    current = null;
    listeners.clear();
  },
};

/** Format PL do HUD: „123 zł" lub „— zł" gdy nieznane. */
export function formatZl(balance: number | null): string {
  const v = balance === null ? null : normalize(balance);
  if (v === null) return '— zł';
  return `${v} zł`;
}
